import React from 'react'

export const DataRoomsContext = React.createContext({
  dataRooms: [],
  loading: false,
  refreshNext: false,
  setRefreshNext: () => {},
  triggerRefresh: () => {},
})

export const MessageContext = React.createContext({
  messageState: {},
  messageDispatch: () => {},
  notificationBarOpen: false,
  setNotificationBarOpen: () => {},
})

export const StatusContext = React.createContext({
  status: {},
})
